export enum SCHEDULE_TYPE {
  multiple_day_rotating = 'MDR',
  same_every_day = 'Same Every Day',
  same_every_day_plus = 'Same Every Day+',
  a_b = 'A/B',
  a_b_plus = 'A/B+',
  monday_through_friday = 'M-F',
}
